// extracted by mini-css-extract-plugin
export var chip = "_c1-0";
export var filterDropdown = "_c1-5";
export var filterItem = "_c1-6";
export var icon = "_c1-1";
export var removeButton = "_c1-3";
export var removeIcon = "_c1-4";
export var separator = "_c1-2";